const pathWithRewrite = (item, { key } = {}) => {
  if (item.rewrite_url) {
    return {
      location: item.rewrite_url,
      target: item.rewrite_target || '_blank'
    };
  } else if (item.rewrite_source) {
    return {
      location: item.rewrite_source,
    }
  } else {
    return {
      location: key ? item[key] : item.path,
    }
  }
  return {
    location: undefined,
  };
}

export default pathWithRewrite;



// WEBPACK FOOTER //
// ./src/utils/pathWithRewrite.js